module.exports = __webpack_public_path__ + "static/img/far2_active.ce4df759.png";